import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {Observable, throwError, of} from 'rxjs';
import { baseUrls } from './appConstant';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class HttpService {  


  tokenFromLocal = localStorage.getItem('userToken') ? localStorage.getItem('userToken') : '';
  isBrowser = false;
  constructor(public httpclient: HttpClient, @Inject(PLATFORM_ID)private platformId: string) {
    if (isPlatformBrowser(platformId)) {
      this.isBrowser = true;
    }
   }
  // constructor(private httpclient:HttpClient) { }
  postFormData(staticUrl:string,data:any):Observable<any> {
    let url=baseUrls['base']+staticUrl;
    return this.httpclient.post(url,data, {  headers: {Token: localStorage.getItem('userToken') ? localStorage.getItem('userToken') : "" }  }).pipe(
      catchError(this.handleError));
  }
  
  getData(staticUrl:string){
    let url = baseUrls['base']+staticUrl;
    return this.httpclient.get(url, {  headers: {Token: localStorage.getItem('userToken') ? localStorage.getItem('userToken') : "" }  });
  }
  //contact Api
  getUser(staticUrl:string){
    // let url = baseUrls['global']+staticUrl;
    let url = baseUrls['apiService']+staticUrl;
    return this.httpclient.get(url, {  headers: {Token: localStorage.getItem('userToken')  ? localStorage.getItem('userToken') : "" }  });
  }
  postDataUser(staticUrl: string,data:any){
    // let url = baseUrls['global'] + staticUrl;
    let url = baseUrls['apiService']+staticUrl;
    let headers: HttpHeaders = new HttpHeaders();
    let tokens=localStorage.getItem('userToken') ? localStorage.getItem('userToken'): '';
    headers = headers.append('Token', tokens);
    return this.httpclient.post(url,data,{headers});
  }
  delDataUser(staticUrl: string){
    // let url = baseUrls['global'] + staticUrl;
    let url = baseUrls['apiService']+staticUrl;
    let headers: HttpHeaders = new HttpHeaders();
    let tokens=localStorage.getItem('userToken')?localStorage.getItem('userToken'):'';
    headers = headers.append('Token', tokens);
    return this.httpclient.delete(url,{headers});
  }
  //
  getDataFromExcel(staticUrl:string){
    let url = staticUrl;
    return this.httpclient.get(url,{ headers: new HttpHeaders({'Content-Type': 'application/json'}), responseType: 'blob'}).pipe(
      catchError(this.handleError));
  }
  getbillData(staticUrl: string){
    let url = baseUrls['bill'] + staticUrl;
    return this.httpclient.get(url);
  }
  
  postFormDataBilling(staticUrl:string,data:any, header: any = ''):Observable<any> {
    const requestOptions = {
      headers: new HttpHeaders(header),
    };
    let url=baseUrls['bill']+staticUrl;
    return this.httpclient.post (url, data, requestOptions).pipe(
      catchError(this.handleError));
  }

  postbillData(staticUrl: string,data:any){
    let url= baseUrls['bill']+staticUrl;
    return this.httpclient.post(url,data, {headers: {Token: this.tokenFromLocal}}).pipe(
      catchError(this.handleError));
  }
  deletebillData(staticUrl: string){
    let url= baseUrls['bill']+staticUrl;
    return this.httpclient.delete(url).pipe(
      catchError(this.handleError));
  }

  getDatadigital(staticUrl: string){
    let url = baseUrls['digi'] + staticUrl;
    let headers: HttpHeaders = new HttpHeaders();
    let tokens=localStorage.getItem('userToken')?localStorage.getItem('userToken'):'';
    headers = headers.append('Token', tokens);
    return this.httpclient.get(url,{headers});
  }
  delDatadigital(staticUrl: string){
    let url = baseUrls['digi'] + staticUrl;
    let headers: HttpHeaders = new HttpHeaders();
    let tokens=localStorage.getItem('userToken')?localStorage.getItem('userToken'):'';
    headers = headers.append('Token', tokens);
    return this.httpclient.delete(url,{headers});
  }
  handleError(error: HttpErrorResponse): Observable<any> {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.log('Backend response', error);
      return of({ success:false,message: 'Something bad happened; please try again later.',error:error.error });
    }
    // return an observable with a user-facing error message
    return of({ success:false,message: 'Something bad happened; please try again later.' });
  }

  putFormData(staticUrl:string,data:any):Observable<any> {
    let url=baseUrls['base']+staticUrl;
    return this.httpclient.put(url,data, {  headers: {Token: localStorage.getItem('userToken') }  }).pipe(
      catchError(this.handleError));
  }
  deleteFormData(staticUrl: string){
    let url= baseUrls['bill']+staticUrl;
    return this.httpclient.delete(url).pipe(
      catchError(this.handleError));
  }

  putGlobalCall(staticUrl: string,data:any):Observable<any> {
    let url=baseUrls['global']+staticUrl;
    return this.httpclient.put(url,data, {  headers: {Token: localStorage.getItem('userToken') }  }).pipe(
      catchError(this.handleError));
  }
  postForShopService(staticUrl: string,data:any){
    if(this.isBrowser){
      let url= baseUrls['shop']+staticUrl;
      if(localStorage.getItem('userToken')){
        return this.httpclient.post (url,data, {headers: {token: localStorage.getItem('userToken')}}).pipe(
          catchError(this.handleError));
      }
      else{
        return this.httpclient.post (url,data).pipe(
          catchError(this.handleError));
      }
    }
  }
  getDigi(staticUrl: string){
    let url = baseUrls['digi'] + staticUrl;
    return this.httpclient.get(url);
  }
  getForShopService(staticUrl: string){
    let url = baseUrls['shop'] + staticUrl;
    if(localStorage.getItem('userToken')){
      return this.httpclient.get(url, {headers :{ token : localStorage.getItem('userToken')}});
    }
    else{
      return this.httpclient.get(url);
    }
  }
  getDatabill(staticUrl: string){
    let url = baseUrls['bill'] + staticUrl;
    return this.httpclient.get(url , { headers: {Token: localStorage.getItem('userToken') ? localStorage.getItem('userToken') : ""}});
  }
}
